import axios from "../plugins/parseAxios";

export class AuditLogAPI {
  static getAuditLogBetweenDateByMarket(formData) {
    return axios.post("functions/getAuditLogBetweenDateByMarket", formData);
  }
}